import BaseMystery from '../BaseMystery'

const FifthLuminousMystery = () => {
	const imagesList = [
		"https://www.wga.hu/art/j/joos/eucharis.jpg",
		"https://www.wga.hu/art/b/barocci/eucharis.jpg",
		"https://www.wga.hu/art/a/angelico/09/cells/35_eucha.jpg",
		"https://www.wga.hu/art/l/lairesse/eucharis.jpg",
		"https://www.wga.hu/art/p/poussin/3/01euchar.jpg",
		"https://www.wga.hu/art/p/poussin/3a/2sacram2.jpg",
		"https://www.wga.hu/art/a/andrea/castagno/1_1440s/08lasts1.jpg",
		"https://www.wga.hu/art/a/andrea/sarto/2/lastsup.jpg",
		"https://www.wga.hu/art/b/bassano/jacopo/1/08lastsu.jpg",
		"https://www.wga.hu/art/b/bassano/leandro/lastsupp.jpg",
		"https://www.wga.hu/art/b/bloemaer/abraham/lastsupp.jpg",
		"https://www.wga.hu/art/b/borras/lastsupp.jpg",
		"https://www.wga.hu/art/b/bouts/dirk_e/lastsupp/1lastsu.jpg",
		"https://www.wga.hu/art/c/caliari/benedett/lastsupp.jpg",
		"https://www.wga.hu/art/c/caylina/paolo2/lastsupp.jpg",
		"https://www.wga.hu/art/c/champaig/philippe/lastsupp.jpg",
		"https://www.wga.hu/art/c/cranach/lucas_y/15lastsu.jpg",
		"https://www.wga.hu/art/c/coecke/lastsupp.jpg",
		"https://www.wga.hu/art/c/crespi/daniele/lastsupp.jpg",
		"https://www.wga.hu/art/d/duccio/maesta/verso_1/verso03.jpg",
		"https://www.wga.hu/art/e/eeckhout/lastsupp.jpg",
		"https://www.wga.hu/art/f/fontebas/lastsupp.jpg",
		"https://www.wga.hu/art/g/gaddi/agnolo/various/lastsup.jpg",
		"https://www.wga.hu/art/g/ghirland/domenico/4lastsup/2ogniss.jpg",
		"https://www.wga.hu/art/g/giotto/padova/3christ/chris13.jpg",
		"https://www.wga.hu/art/g/greco_el/02/0207grec.jpg",
		"https://www.wga.hu/art/h/henrique/lastsupp.jpg",
		"https://www.wga.hu/art/h/holbein/hans_y/1525/10lastsu.jpg",
		"https://www.wga.hu/art/j/jacomart/lastsupp.jpg",
		"https://www.wga.hu/art/j/juanes/0lastsup.jpg",
		"https://www.wga.hu/art/j/juanes/1lastsup.jpg",
		"https://www.wga.hu/art/l/leonardo/05copies/7lastsup.jpg",
		"https://www.wga.hu/art/l/lorenzet/pietro/1/1vault/2lastsu.jpg",
		"https://www.wga.hu/art/l/lorenzo/monaco/1/04monaco.jpg",
		"https://www.wga.hu/art/m/master/hausbuch/lastsupp.jpg",
		"https://www.wga.hu/art/p/perugino/christ/lastsupp.jpg",
		"https://www.wga.hu/art/p/pourbus/frans_y/lastsupp.jpg",
		"https://www.wga.hu/art/p/pourbus/pieter/lastsupp.jpg",
		"https://www.wga.hu/art/r/rosselli/cosimo/lastsup.jpg",
		"https://www.wga.hu/art/r/rubens/14religi/72religj.jpg",
		"https://www.wga.hu/art/t/tiepolo/gianbatt/3_1740s/08lastsu.jpg",
		"https://www.wga.hu/art/t/tintoret/4_1570s/1lastsu2.jpg",
		"https://www.wga.hu/art/t/tintoret/5_1580s/3lastsup.jpg",
		"https://www.wga.hu/art/v/valentin/lastsupp.jpg",
		"https://www.wga.hu/art/v/vazquez/lastsupp.jpg",
		"https://www.wga.hu/art/v/veen/lastsupp.jpg",
		"https://www.wga.hu/art/v/vouet/1/4lastsup.jpg",
	];

	const scriptureQuote = "Then he took the bread, said the blessing, broke it, and gave it to them, saying, \"This is my body, which will be given for you; do this in memory of me.\"";
	const scriptureCitation = "Luke 22:19 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Luke%2022%3A14-38&version=NABRE";

	return (
		<BaseMystery titleText="The Institution of the Eucharist"
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={false} />
	);
};

export default FifthLuminousMystery;